"use client"

import { useRef, useState, useTransition } from 'react';
import s from './languages.module.scss'
import { useLocale } from 'next-intl';
import { usePathname, useRouter } from 'next/navigation';
import Image from 'next/image';
import { ArrowDownIcon } from '@/theme/assets/icons'
import cn from 'classnames'
import { useOutSideCkick } from '@/lib/hook';

export const LanguagesSwitch = ({ type, page = null }) => {
    const languages = [
        {
            title: 'Chinese',
            value: 'CN',
            key: 'cn',
            icon: '/icon/flag/Language=CN.svg'
        },
        {
            title: 'English',
            value: 'En',
            key: 'en',
            icon: '/icon/flag/Language=US.svg'
        },
        {
            title: 'French',
            value: 'FR',
            key: 'fr',
            icon: '/icon/flag/Language=FR.svg'
        },
        {
            title: 'German',
            value: 'DE',
            key: 'de',
            icon: '/icon/flag/Language=DE.svg'
        },
        {
            title: 'Italian',
            value: 'IT',
            key: 'it',
            icon: '/icon/flag/Language=IT.svg'
        },
        {
            title: 'Polish',
            value: 'PL',
            key: 'pl',
            icon: '/icon/flag/Language=PL.svg'
        },
        {
            title: 'Romanian',
            value: 'RO',
            key: 'ro',
            icon: '/icon/flag/Language=RO.svg'
        },
        {
            title: 'Russian',
            value: 'RU',
            key: 'ru',
            icon: '/icon/flag/Language=RU.svg'
        },
        {
            title: 'Spanish',
            value: 'ES',
            key: 'es',
            icon: '/icon/flag/Language=ES.svg'
        },
        {
            title: 'Turkish',
            value: 'TR',
            key: 'tr',
            icon: '/icon/flag/Language=TR.svg'
        },
        {
            title: 'Ukrainian',
            value: 'UA',
            key: 'ua',
            icon: '/icon/flag/Language=UA.svg'
        }
    ]
    const ref = useRef()
    const [mobile, setMobile] = useState(false)

    const [openLanguages, setOpenLanguages] = useState(false)

    const [isPending, startTransition] = useTransition();
    const router = useRouter();
    const localActive = useLocale();
    const pathname = usePathname();

    const onSelectChange = (nextLocale) => {
        setOpenLanguages(false)
        startTransition(() => {
			const regex = new RegExp(`^/(${languages.map(l => l.key).join('|')})`)
			const cleanedPathname = pathname.replace(regex, '') // Remove the current locale
			router.replace(`/${nextLocale}${cleanedPathname}`)
		})
    };
    const closeHandler = () => {
        setOpenLanguages(false)
    }
    useOutSideCkick(ref, closeHandler, openLanguages)

    return (
        <>
            <div className={cn(s.languages_wrapper, {
                [s.light]: type === 'light',
                [s.auth]: page === 'auth'
            })}>
                {languages.map((el) => {
                    if (el.key === localActive) {
                        return (
                            <div onClick={() => setOpenLanguages(!openLanguages)} key={el.key} className={cn(s.languages_wrapper, s.main_wrap)}>
                                <span className={s.flag_icon}>
                                    <Image src={el.icon} width={20} height={20} alt="Karavan" className={s.flag} />
                                </span>
                                <span>{page === 'auth' ? el.value : el.title}</span>
                                <span className={cn(s.arrow_wrapper, {
                                    [s.arrow_active]: openLanguages
                                })}>
                                    <ArrowDownIcon />
                                </span>

                            </div>
                        )
                    }
                })}
                <div className={cn(s.dropdown, {
                    [s.dropdown_active]: openLanguages,
                    [s.mobile]: mobile
                })} ref={ref}>
                    {mobile && (
                        <div className={s.title}>Select languages</div>
                    )}
                    {languages.map((item, i) => {
                        return (
                            <div className={cn(s.dropdown_item, {
                                [s.active]: item.key === localActive
                            })} key={i} onClick={() => onSelectChange(item.key)} ><span className={s.flag_icon}>
                                    <Image src={item.icon} width={20} height={20} alt="Karavan" className={s.flag} />
                                </span>{item.title}
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}